import { render } from "./CourseRegistry.vue?vue&type=template&id=4dae9796"
import script from "./CourseRegistry.vue?vue&type=script&lang=js"
export * from "./CourseRegistry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__